import React, { useEffect } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { useIntersectionObserver } from '@vk-hr-tek/ui/hooks';

import { NotificationItemSkeleton } from '../NotificationItemSkeleton';

interface IntersectionNotificationItemSkeletonProps {
  onIntersect: () => void;
}

export const IntersectionNotificationItemSkeleton = ({
  onIntersect,
}: IntersectionNotificationItemSkeletonProps) => {
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: '100px',
  });

  useEffect(() => {
    if (entry?.isIntersecting) {
      onIntersect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry?.isIntersecting]);

  return (
    <Box ref={ref}>
      <NotificationItemSkeleton />
    </Box>
  );
};
